import React from 'react';
import { scroller } from 'react-scroll';

import { type WallType } from '~/vendor/cx-sdk/types';

interface Wallable {
  isWalled: boolean;
  wallType?: WallType;
}

export function withLock<P extends object, R = any>(
  WrappedComponent: React.ComponentType<P>,
  scrollTo: string,
  gridArea?: string,
) {
  const LockedComponent = React.forwardRef<R, Omit<P, keyof Wallable> & Wallable>(
    // @ts-ignore
    ({ isWalled = false, ...props }, ref) => {
      if (!isWalled) {
        return <WrappedComponent {...(props as P)} ref={ref} />;
      }

      const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent> | React.TouchEvent<HTMLDivElement>) => {
        e.stopPropagation();
        scroller.scrollTo(scrollTo, {
          duration: 500,
          delay: 100,
          smooth: true,
          offset: -100,
        });
      };
      const gridStyles = gridArea ? { gridArea } : {};

      return (
        <div onClick={handleClick} onTouchStart={handleClick} style={{ overflow: 'hidden', ...gridStyles }}>
          <div style={{ pointerEvents: 'none' }}>
            <WrappedComponent {...(props as P)} isDisabled ref={ref} />
          </div>
        </div>
      );
    },
  );

  LockedComponent.displayName = `Locked${WrappedComponent.displayName || WrappedComponent.name || 'Component'}`;

  return LockedComponent;
}
